import { defineStyle, defineStyleConfig } from '@chakra-ui/react'

const baseStyle = defineStyle({
    container: {
        maxW: "562px",
        w: "100%",
        alignItems: "flex-start",
    },
    label: {
        color: "primary.runningText",
        fontStyle: "normal",
        fontWeight: 400,
        lineHeight: "20px",
        mb: "5px",
        "&.chakra-checkbox__label": {
            fontSize: "14px",
        }
    },
    control: {
        mt: "4px",
        borderColor: "primary.runningText",
    },
    icon: {},
});

const disabledIcon = defineStyle({
    container: {
        w: "auto",
    },
    label: {
        display: "flex",
        gap: "8px",
        _disabled: {
            opacity: 1,
            marginLeft: "4px",
            alignItems: "center",
        }
    },
    control: {
        _disabled: {
            _checked: {
                color: "white",
                bgColor:"#D0D0D0",
                border:"none",
            }
        }
    },
    icon: {},
});


const brand = defineStyle({});

const checkboxTheme = defineStyleConfig({
    baseStyle,
    variants: { brand, disabledIcon },
    defaultProps: {
        variant: "brand",
    },
});
export default checkboxTheme;
